var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-check-button",on:{"click":function($event){$event.preventDefault();return _vm.onClickCheck.apply(null, arguments)}}},[_c('span',{staticClass:"g-check-button__inner"},[_c('i',{class:[
        'g-check-button__check',
        { 'g-check-button__check--checked': _vm.checked }
      ]}),_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }